import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { useQuote } from "@/components/QuoteProvider";

export default function NotFound() {
    const { openQuote } = useQuote();
    return (
        <section className="relative overflow-hidden bg-navy-dark py-24 text-white md:py-36" data-testid="not-found-page">
            <div className="absolute inset-0 bg-blueprint" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-brand-red">Error 404</p>
                <h1 className="mt-6 text-5xl font-bold tracking-tight md:text-6xl">
                    This page is off the board.
                </h1>
                <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-slate-300">
                    The page you are looking for does not exist or has moved. Head back to the
                    homepage, or tell us what you need — we manufacture PCBs to your design.
                </p>
                <div className="mt-10 flex flex-wrap gap-4">
                    <Link
                        to="/"
                        data-testid="not-found-home-link"
                        className="inline-flex items-center gap-2 border border-brand-red bg-brand-red px-7 py-3.5 text-[13px] font-semibold uppercase tracking-wider text-white transition-colors hover:bg-brand-redhover"
                    >
                        <Home className="h-4 w-4" /> Back to Home
                    </Link>
                    <button
                        onClick={openQuote}
                        data-testid="not-found-quote-btn"
                        className="group inline-flex items-center gap-2 border border-navy-line bg-navy/40 px-7 py-3.5 text-[13px] font-semibold uppercase tracking-wider text-white transition-colors hover:border-slate-400"
                    >
                        Get a Quote
                        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                    </button>
                </div>
            </div>
        </section>
    );
}
